import { OrderDetail } from '@insurance/api/requests'
import { Divider } from 'antd'

import { CmrInsuranceProvider } from './CmrInsuranceContext'
import { CustomerStep } from './CustomerStep'
import { InformationStep } from './InformationStep'
import { MainStep } from './MainStep'
import { normalizeOrderData } from './utils'

type Props = { order: OrderDetail }

export const ApproveCmrOrderFields = ({ order }: Props) => {
  return (
    <CmrInsuranceProvider isEditable={false} isApprove order={order}>
      <MainStep />
      <Divider />
      <InformationStep />
      <Divider />
      <CustomerStep />
    </CmrInsuranceProvider>
  )
}

ApproveCmrOrderFields.normalizeOrderData = normalizeOrderData
